<div class="fs-4 mb-4">Zvolený termín</div>
<div class="card text-dark">
    <div class="card-body p-4">
        <div class="card-content">

          <p class="fs-3"><strong>{{toTime(this.firstTerm)}} - {{toTime(this.lastTerm)}}</strong></p>
          <p><small>{{toDate(this.from)}}</small></p>
          <p>Areál MN Čáslav Hematologicko-transfúzní oddělení</p>

        </div>
    </div>
</div>
